import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Code from '../Code';
import formatObjectField from '../../utils/formatObjectField';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import './styles.css';

class ScriptSelector extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { scripts } = this.props;

    let tabs = [];

    for (let name in scripts) {
      tabs.push(
        <Tab
          eventKey={name}
          title={formatObjectField(name)}
          key={name}>
          <Code code={scripts[name]}/>
        </Tab>
      );
    }

    return (
      <div id="script-selector__tabs">
        <Tabs defaultActiveKey={Object.keys(scripts)[0]}>
          { tabs }
        </Tabs>
      </div>
    );
  }
}

ScriptSelector.propTypes = {
  scripts: PropTypes.object.isRequired
};

export default ScriptSelector;
